export interface FocusHandlerOptions {
  setFocused: (value: boolean) => void;
  getListeners: () => Record<string, unknown>;
}


export function createFocusBlurHandlers(options: FocusHandlerOptions) {
  const { setFocused, getListeners } = options;

  function handleFocus(event: FocusEvent): void {
    setFocused(true);
    const listeners = getListeners().focus;
    if (listeners) {
      if (Array.isArray(listeners)) {
        listeners.forEach(fn => fn(event));
      } else {
        (listeners as (event: FocusEvent) => void)(event);
      }
    }
  }

  function handleBlur(event: FocusEvent): void {
    setFocused(false);
    const listeners = getListeners().blur;
    if (listeners) {
      if (Array.isArray(listeners)) {
        listeners.forEach(fn => fn(event));
      } else {
        (listeners as (event: FocusEvent) => void)(event);
      }
    }
  }

  return {
    handleFocus,
    handleBlur,
  };
}

export interface VuetifyInputRef {
  activateMenu?: () => void;
  focus?: () => void;
  blur?: () => void;
  isMenuActive?: boolean;
  search?: string;
}

export function createListenersWithFocusHandlers(
  listeners: Record<string, unknown>,
  focusHandlers: ReturnType<typeof createFocusBlurHandlers> | null,
): Record<string, unknown> {
  const result: Record<string, unknown> = {};

  for (const [key, value] of Object.entries(listeners)) {
    if (key !== 'focus' && key !== 'blur') {
      result[key] = value;
    }
  }

  // Add our wrapped focus/blur handlers
  if (focusHandlers) {
    result.focus = focusHandlers.handleFocus;
    result.blur = focusHandlers.handleBlur;
  }

  return result;
}
